// ── 테넌트 관리자 회사 추가 패널 (업무/기능 배정) ──────────────────────────────
// 테넌트 관리자가 자기 테넌트에 새 회사를 추가(생성+연결). 운영자/위임자에겐 노출 안 함(호출 측 게이트).
//   백엔드 POST /admin/saas/my-tenant/companies 가 로그인 컨텍스트로 테넌트를 해석 → 코드·표시명만 전송.
//   추가 후 회사 메뉴는 전부 OFF → 고객사 기능 배정의 '회사별 메뉴'에서 켜야 직원에게 배정 가능(2026-10-20 문구).
import React, { useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { useToast } from '../../../components/Toast';

const wrap = { border: '1px solid var(--border)', borderRadius: 8, background: 'var(--bg-card)', padding: 14, display: 'flex', flexDirection: 'column', gap: 10 };
const input = { padding: '7px 10px', border: '1px solid var(--border)', borderRadius: 7, fontSize: 13, background: 'var(--bg-card)', color: 'var(--text)' };
const btn = { padding: '7px 14px', border: 'none', borderRadius: 7, background: 'var(--mm-tone-blue-solid-bg)', color: 'var(--mm-tone-blue-solid-text)', fontWeight: 700, fontSize: 13, cursor: 'pointer' };

export default function CompanyAddPanel({ onAdded }) {
  const { showToast } = useToast();
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  async function addCompany() {
    const c = code.trim();
    const n = name.trim();
    if (!c) { showToast('회사 코드를 입력하세요 (영문 대문자·숫자).', 'error'); return; }
    if (!n) { showToast('표시명을 입력하세요.', 'error'); return; }
    setSaving(true);
    const res = await apiClient.post('/api/admin/saas/my-tenant/companies', { code: c, name: n });
    setSaving(false);
    if (!res.ok) { showToast(res.data?.message || '회사 추가에 실패했습니다.', 'error'); return; }
    showToast(`회사 '${n}(${c})'를 추가했습니다. 고객사 기능 배정의 '회사별 메뉴'에서 사용할 메뉴를 켜 주세요.`, 'success');
    setCode(''); setName('');
    if (onAdded) await onAdded();
  }

  return (
    <div style={wrap}>
      <strong style={{ fontSize: 14 }}>회사 추가</strong>
      <p style={{ margin: 0, fontSize: 12, color: 'var(--text-muted)' }}>
        우리 테넌트 안에 새 회사를 추가합니다. 추가 후 사용할 메뉴를 켜고 직원에게 배정하세요.
      </p>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          style={{ ...input, width: 170 }}
          placeholder="회사 코드(영문대문자)"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 20))}
        />
        <input
          style={{ ...input, flex: 1, minWidth: 180 }}
          placeholder="표시명(예: 우리지점)"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button style={{ ...btn, opacity: saving ? 0.6 : 1 }} disabled={saving} onClick={addCompany}>
          {saving ? '추가 중…' : '추가'}
        </button>
      </div>
    </div>
  );
}
